import React from 'react';
import validationHelper from 'helpers/validation.helper';

class PasswordStrengthMeter extends React.Component {
  render() {
    const { translate, password } = this.props;
    let text = '';

    const level = validationHelper.passStrengthMeter(password);

    if(level <= 3) {
      text = translate('session.common.password_strength.low');
    } else if(level === 4) {
      text = translate('session.common.password_strength.medium');
    } else {
      text = translate('session.common.password_strength.strong');
    }

    return (
      <React.Fragment>
        <ul className="password-strength-meter">
          <li className="bg-danger highlighted"></li>
          <li className={"bg-danger " + (level >= 1 ? 'highlighted' : '')}></li>
          <li className={"bg-danger " + (level >= 1 ? 'highlighted' : '')}></li>
          <li className={"bg-warning " + (level >= 2 ? 'highlighted' : '')}></li>
          <li className={"bg-warning " + (level >= 2 ? 'highlighted' : '')}></li>
          <li className={"bg-warning " + (level >= 3 ? 'highlighted' : '')}></li>
          <li className={"bg-success " + (level >= 4 ? 'highlighted' : '')}></li>
          <li className={"bg-success " + (level >= 4 ? 'highlighted' : '')}></li>
          <li className={"bg-success " + (level >= 5 ? 'highlighted' : '')}></li>
        </ul>
        <small>{text}</small>
      </React.Fragment>
    );
  }
};

export default PasswordStrengthMeter;



// WEBPACK FOOTER //
// ./src/components/common/form/passwordStrengthMeter.js